<template>
  <div class="changePsw_box">
    <div class="change_psw_form ipad_form">
      <li class="form_item">
        <p class="title"> {{$t('toast.pswTitle1')}}</p>
        <div class="form_input">
          <input :type="seeFlag1?'text':'password'"
                 v-model="password"
                 :placeholder="$t('toast.pswTitle1')"
                 class="phone">
          <span class="visible_icon"
                @click="seeFlag1=!seeFlag1">
            <img :src="seeFlag1?img1:img2"
                 alt="">
          </span>
        </div>
      </li>
      <li class="form_item">
        <p class="title"> {{$t('toast.pswTitle2')}}</p>
        <div class="form_input ">
          <input :type="seeFlag2?'text':'password'"
                 v-model="repeatpsw"
                 :placeholder="$t('toast.pswTitle2')"
                 class="phone">
          <span class="visible_icon"
                @click="seeFlag2=!seeFlag2">
            <img :src="seeFlag2?img1:img2"
                 alt="">
          </span>
        </div>
      </li>
      <li class="form_item "
          :class="noclickFlag?'form_submit':'form_no_submit'"
          ref="form_submit"
          @click="submitAccount">
        {{$t('toast.comfirmBtn1')}}
      </li>
    </div>
  </div>
</template>

<script>
import { appPostMessage } from '@/utils/communication'
import { getSessionStorage, setSessionStorage } from '@/utils/stage'
import { key } from '@/api/login'
import { set_password } from '@/api/hw'
import { encrypt, encodeBase64, HmacSHA256, randomString } from '@/utils/crypto'
export default {
  data() {
    return {
      img1: require('../../assets/images/visible_icon.png'),
      img2: require('../../assets/images/invisible_icon.png'),
      seeFlag1: this.img1,
      seeFlag2: false,
      loginFlag: false,
      password: '',
      repeatpsw: '',
      username: '',
      show: false,
      value: '',
      noclickFlag: false,
    }
  },
  watch: {
    repeatpsw(newval) {
      if (newval && this.password) {
        this.noclickFlag = true
      } else {
        this.noclickFlag = false
      }
    },
    password(newval) {
      if (newval && this.repeatpsw) {
        this.noclickFlag = true
      } else {
        this.noclickFlag = false
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      this.verify_code = getSessionStorage('accountveifyOne')
      console.log('this.verify_code', this.verify_code)
    },
    openValue() {
      this.show = !this.show
    },
    getvalue(index, item) {
      this.value = item.name
      this.show = false
    },
    repeatPsw() {
      if (this.repeatpsw != this.password) {
        this.$toast(this.$t('toast.comfirmPswTips'))
      }
    },
    submitAccount() {
      if (this.loginFlag) {
        return
      }
      this.loginFlag = true
      setTimeout(() => {
        this.loginFlag = false
      }, 2000)
      if (this.password === '') {
        this.$toast(this.$t('toast.nopsw'))
        return
      }
      if (this.repeatpsw != this.password) {
        this.$toast(this.$t('toast.comfirmPswTips'))
        return
      }
      //   const reg =
      //     /^[0-9a-zA-Z`~!@#$%^&*()+=|\[\]{}\':;,.<>?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、]{6,18}$/
      //   // const reg = /^[a-zA-Z0-9`~!@#$%^&*()+=|\\[\\]{}\':;,.<>?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、]{6,18}/
      //   // const reg = /^[0-9a-zA-Z]{6,18}$/
      //   if (!reg.test(this.password)) {
      //     this.$toast(this.$t('toast.verifypswTips'))
      //     return
      //   }
      const msg1 = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        {}
      )
      const iv = randomString(16)
      const iv_data = encodeBase64(iv)
      key(msg1)
        .then((res) => {
          this.ft_key = res.data.ft_key
          this.encrypted_data = encrypt(this.password, this.ft_key, iv)
          const mac = iv_data + this.encrypted_data
          this.mac_data = HmacSHA256(mac, this.ft_key)
        })
        .then(() => {
          const passport = {
            body: this.encrypted_data,
            iv: iv_data,
            mac: this.mac_data,
          }
          const access_token = JSON.parse(
            getSessionStorage('accountStorage')
          ).access_token
          const password = encodeBase64(JSON.stringify(passport))
          const data = {
            csrf_token: this.verify_code,
            token: this.token,
            password: password,
            ft_key: this.ft_key,
            access_token,
          }
          const msg = Object.assign(
            JSON.parse(JSON.stringify(this.configData)),
            data
          )
          set_password(msg).then((res) => {
            if (res.errcode === 0) {
              const accountStorage = JSON.parse(
                getSessionStorage('accountStorage')
              )
              accountStorage.access_token = res.data.access_token
              //   const userEntity = res.data.user_entity
              const user_entity = JSON.stringify(accountStorage)
              setSessionStorage('accountStorage', user_entity)
              const data = { access_token: res.data.access_token }

              this.$router.push({ path: '/success', query: { id: 4 } })
              const appmsg = { code: 3, data: data }
              appPostMessage(appmsg)
            }
          })
        })
    },
    ifCanSee(data) {
      data = !data
    },
  },
}
///
</script>

<style lang="less" scoped>
.changePsw_box {
  padding: 30/75rem;
}
.change_psw_form {
  //   padding-left: 30/75rem;
  .user_name {
    font-size: 26/75rem;
    color: #a8a8a8;
    .username {
      margin-left: 30/75rem;
    }
  }
  .form_item {
    margin-bottom: 30/75rem;
    .title {
      font-size: 26/75rem;
      font-family: 'Microsoft YaHei';
      line-height: 48/75rem;
      color: #000000;
      text-align: left;
    }
    .form_input {
      width: 610/75rem;
      height: 76/75rem;
      border: 1/75rem solid #575757;
      opacity: 1;
      border-radius: 6/75rem;
      padding-left: 30/75rem;
      padding-top: 21/75rem;
      box-sizing: border-box;
      margin: 0 auto;
      padding-right: 65/75rem;
      position: relative;
      .visible_icon {
        display: inline-block;
        width: 35/75rem;
        height: 35/75rem;
        position: absolute;
        top: 22/75rem;
        right: 30/75rem;
        //   float: right;
        //   margin-top: ;
      }
      .phone {
        border: none;
        outline: none;
        width: 100%;
        height: 34/75rem;
      }
      .psw {
        border: none;
        outline: none;
        width: 470/75rem;
        width: 100%;
      }
    }
    .psw_input {
      padding-right: 180/75rem;
      box-sizing: border-box;
      position: relative;
      .psw_btn {
        position: absolute;
        display: inline-block;
        width: 180/75rem;
        right: 0;
        top: 0;
        height: 76/75rem;
        line-height: 76/75rem;
        letter-spacing: 5/75rem;
        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 1px;
          height: 45/75rem;
          background: #cfcfcf;
          transform: translateY(-50%);
        }
      }
    }
  }
  .select_box {
    outline: none;
    border: none;
  }
}
</style>